











 











const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MoveReflectTemplatePromptMutation_team",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ReflectPrompt",
      "kind": "LinkedField",
      "name": "prompt",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sortOrder",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "templateId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MoveReflectTemplatePromptPayload",
  "abstractKey": null
};

(node ).hash = "1970acbb466edf89b581ce495bfd4897";

export default node;
